const ALL_ICONS = [
  'add',
  'home',
  'search',
  'favorites-outlined',
  'favorites',
  'areas',
  'airline',
  'mro',
  'handling',
  'central-services',
  'close',
  'iberia',
  'iberia-dark',
  'close',
  'certified',
  'delete',
  'edit',
  'lock',
  'info',
  'views',
  'refreshDate',
  'launch',
  'open-external',
  'account',
  'none',
  'logout',
  'theme',
] as const;

type IconIdTuple = typeof ALL_ICONS;

export type IconId = IconIdTuple[number];

const isIconId = (value: string): value is IconId => ALL_ICONS.includes(value as IconId);

export const getIconId = (value: string): IconId => {
  const valueWithIconFormat = value.replace(/\s+/g, '-').toLowerCase();
  return isIconId(valueWithIconFormat) ? valueWithIconFormat : 'none';
};
